module.exports = __webpack_public_path__ + "static/media/life_pro_tips_book_promo_1200x628.89684a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/life_pro_tips_book_promo_1200x628.jpg
// module id = 237
// module chunks = 0